import { requestFlat, requestFlatPeriod } from './requestFlat';
import {
  flatRequestColorsMap,
  requestInPeriodColorMap,
} from './stagesColorMaps';

export const reqestForFlat = [
  {
    id: 1,
    value: 'Новая',
    bg: flatRequestColorsMap.get(requestFlat.NEW_REQUEST) || 'transparent',
  },
  {
    id: 2,
    value: 'В работе',
    bg: flatRequestColorsMap.get(requestFlat.WORK_REQUEST) || 'transparent',
  },
  {
    id: 3,
    value: 'Выполнена / Выполнена (контроль качества)',
    bg:
      flatRequestColorsMap.get(requestFlat.COMPLETED_REQUEST) || 'transparent',
  },
  {
    id: 4,
    value: 'Закрыта',
    bg: flatRequestColorsMap.get(requestFlat.CLOSE_REQUEST) || 'transparent',
  },
];

export const requestInFlatPeriodIndicators = [
  {
    id: requestFlatPeriod.finishingTouches,
    value: 'Чистовая отделка',
    bg: requestInPeriodColorMap.get(requestFlatPeriod.finishingTouches),
  },
  {
    id: requestFlatPeriod.rightTime,
    value: 'Заявки с подходящим сроком выполнения',
    bg: requestInPeriodColorMap.get(requestFlatPeriod.rightTime),
  },
  {
    id: requestFlatPeriod.expired,
    value: 'Просроченные заявки',
    bg: requestInPeriodColorMap.get(requestFlatPeriod.expired),
  },
  {
    id: requestFlatPeriod.excess,
    value: 'Превышения проверочной даты',
    bg: requestInPeriodColorMap.get(requestFlatPeriod.excess),
  },
];
